import { IntlShape } from 'react-intl';
import { ModuleHierachy } from '../../common/module/types';

import {
  ACTIVITY_TRACKING_BASE_PATH,
  ACTIVITY_TRACKING_TITLE,
  QR_CODE_ACTIVITY_CATEGORY_PATH,
  QR_CODE_ACTIVITY_CATEGORY_TITLE,
  QR_CODE_ACTIVITY_CATEGORY_NAMESPACE,
  QR_CODE_ACTIVITY_TYPE_PATH,
  QR_CODE_ACTIVITY_TYPE_TITLE,
  QR_CODE_ACTIVITY_TYPE_NAMESPACE,
  QR_ACTIVITY_REPORT_PATH,
  QR_ACTIVITY_REPORT_TITLE,
  QR_ACTIVITY_REPORT_NAMESPACE,
  ActivityTrackingPermissionType,
} from './constans';

import QRCodeActivityCategoryPage from './pages/QRCodeActivityCategory/QRCodeActivityCategoryPage';
import QRCodeActivityTypePage from './pages/QRCodeActivityType/QRCodeActivityTypePage';
import QRActivityReportPage from './pages/QRActivityReport/QRActivityReportPage';
import { isPermitted } from 'src/app/common/utils';

export const activityTrackingModuleConfig = (permissions: string[], intl: IntlShape): ModuleHierachy => {
  const Translation = (id: string) => intl.formatMessage({ id });

  return {
    title: Translation(ACTIVITY_TRACKING_TITLE),
    path: ACTIVITY_TRACKING_BASE_PATH,
    icon: '/media/svg/icons/General/AdminMenu.svg',
    enableRead: isPermitted(Object.values(ActivityTrackingPermissionType), permissions),
    child: [
      {
        title: Translation(QR_CODE_ACTIVITY_CATEGORY_TITLE),
        path: `${ACTIVITY_TRACKING_BASE_PATH}${QR_CODE_ACTIVITY_CATEGORY_PATH}`,
        namespace: QR_CODE_ACTIVITY_CATEGORY_NAMESPACE,
        component: QRCodeActivityCategoryPage,
        enableRead: isPermitted(
          [
            ActivityTrackingPermissionType.QR_CATEGORY_READ,
            ActivityTrackingPermissionType.QR_CATEGORY_CREATE,
            ActivityTrackingPermissionType.QR_CATEGORY_UPDATE,
          ],
          permissions,
        ),
        enableCreate: isPermitted([ActivityTrackingPermissionType.QR_CATEGORY_CREATE], permissions),
        enableUpdate: isPermitted([ActivityTrackingPermissionType.QR_CATEGORY_UPDATE], permissions),
      },
      {
        title: Translation(QR_CODE_ACTIVITY_TYPE_TITLE),
        path: `${ACTIVITY_TRACKING_BASE_PATH}${QR_CODE_ACTIVITY_TYPE_PATH}`,
        namespace: QR_CODE_ACTIVITY_TYPE_NAMESPACE,
        component: QRCodeActivityTypePage,
        enableRead: isPermitted(
          [
            ActivityTrackingPermissionType.QR_TYPE_READ,
            ActivityTrackingPermissionType.QR_TYPE_CREATE,
            ActivityTrackingPermissionType.QR_TYPE_UPDATE,
          ],
          permissions,
        ),
        enableCreate: isPermitted([ActivityTrackingPermissionType.QR_TYPE_CREATE], permissions),
        enableUpdate: isPermitted([ActivityTrackingPermissionType.QR_TYPE_UPDATE], permissions),
      },
      {
        title: Translation(QR_ACTIVITY_REPORT_TITLE),
        path: `${ACTIVITY_TRACKING_BASE_PATH}${QR_ACTIVITY_REPORT_PATH}`,
        namespace: QR_ACTIVITY_REPORT_NAMESPACE,
        component: QRActivityReportPage,
        enableRead: isPermitted([ActivityTrackingPermissionType.QR_REPORT_READ], permissions),
      },
    ],
  };
};
